import React from "react";

import { List, Edit, Create, Datagrid, SimpleForm, TextInput, DeleteButton, EditButton, TextField } from "react-admin";

import { ReferenceArrayInput, SelectArrayInput } from "react-admin";

import LargePagination from "../core/LargePagination";
import { LVEditToolbar, LVCreateToolbar } from "../core/toolbars";

export const RoleGroupList = (props) => (
    <List title="All groups" perPage={500} pagination={<LargePagination />} {...props}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="name" />
            <EditButton />
            <DeleteButton mutationMode="pessimistic"/>
        </Datagrid>
    </List>
);

const classes = {
    textInput: {
        display: "flex",
        width: "20rem",
    },
};

const GroupTitle = ({ record }) => {
    return <span>Group {record ? `"${record.name}"` : ""}</span>;
};

const validateGroupCreation = (values) => {
    const errors = {};

    if (!values.name) {
        errors.name = "The Role Group Name is required";
    }
    if (!values.roleIds || !(values?.roleIds?.length > 0)) {
        errors.roleIds = "Roles is required";
    }
    return errors;
};

const CoreFields = () => {
    return (
        <>
            <TextInput label="Group Name" source="name" sx={classes.textInput} />
        </>
    );
};

export const RoleGroupCreate = (props) => (
    <Create title="Create Group" {...props}>
        <SimpleForm validate={validateGroupCreation} toolbar={<LVCreateToolbar />}>
            <div>Create new group</div>

            <CoreFields classes={classes} />

            <ReferenceArrayInput label="Roles" source="roleIds" reference="portal/roles" style={{ width: "100%" }}>
                <SelectArrayInput optionText={(s) => s.id + ": " + s.name} />
            </ReferenceArrayInput>
        </SimpleForm>
    </Create>
);

export const RoleGroupEdit = (props) => (
    <Edit title={<GroupTitle />} {...props}>
        <SimpleForm toolbar={<LVEditToolbar />}>
            <TextInput disabled source="id" />

            <CoreFields classes={classes} />

            <ReferenceArrayInput
                label="Roles"
                source="roleIds"
                reference="portal/roles"
                sort={{ field: "id", order: "ASC" }}
                style={{ width: "100%" }}
            >
                <SelectArrayInput optionText={(s) => s.id + ": " + s.name} />
            </ReferenceArrayInput>
        </SimpleForm>
    </Edit>
);
